module.exports = __webpack_public_path__ + "img/2012-08-18 09.12.51.67803459.jpg";